import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SACE（S即興・Aアクティブ・C安心安定・E体験） */
const saceContent: DiagnosisResultContent = {
  code: 'SACE',
  name: 'ゆるふわアドベンチャー',
  catchphrase: '「面白そう」を気軽に拾う、ゆるくて行動派の冒険者',
  rarity: 3,
  style:
    '「気軽に、でもしっかり動く」ゆるアクティブ派。きっちり計画はしないが、安心できる範囲で「面白そう」を次々に拾って動く。冒険的すぎず、定番の体験を即興で楽しむのが得意。重く考えず、ノリの良さと安全志向を両立する。気負わず誰とでも楽しめる、フットワーク軽めの体験コレクタータイプ。',
  strengths: [
    { lead: '気軽さが武器', text: '思い立ったらすぐ動け、体験のチャンスを逃さない。' },
    { lead: '安心の範囲で冒険', text: '無茶はせず、定番アクティビティを即興で楽しめる。' },
    { lead: '一緒にいて楽', text: 'ノリがよく気負いがないので、同行者が構えずに済む。' },
  ],
  weaknesses: [
    { lead: '深まりにくい', text: '広く浅く動くため、一つの体験を掘り下げる機会が少ない。' },
    { lead: '詰めの甘さ', text: '即興ゆえに予約漏れや段取り不足が起きやすい。' },
    { lead: '流されやすい', text: '「面白そう」に乗りすぎて、当初の目的を見失うことも。' },
  ],
  aaru: [
    { icon: 'msg', text: '「ちょっと行ってみる？」が口癖' },
    { icon: 'camera', text: '体験系アクティビティが好き' },
    { icon: 'coffee', text: '気になった店にふらり' },
    { icon: 'camera', text: '当日見つけたイベントに参加' },
  ],
  manual: {
    good: '気軽な提案に乗る／一緒に面白がる',
    ng: '「ちゃんと下調べした？」と問い詰める',
    tips: '人気体験だけ予約しておけば即興でも安心',
  },
  compatibility: {
    good: 'SACZ（脱力系）／PRCE（バランス）',
    conflict: 'PRLE（探究型）／PACZ（慎重計画）',
    tips: 'やりたい体験を1つ共有すると動きやすい',
  },
  destinations: {
    domestic: '横浜（気軽に体験を拾える）／神戸（街歩きと食の即興）',
    overseas: 'シンガポール（安心して気軽に動ける）／台湾（ゆる冒険向き）',
  },
};

export const saceDiagnosisResult = buildDiagnosisResult(saceContent);
